import dayjs from '@/libs/dayjs'
import { parseJwt } from '@/libs/helpers'
import { useAppStore } from '@/stores/app'

export const isAuthenticated = (): boolean => {
    try {
        const jwt = localStorage.getItem('JWT')
        if (!jwt) return false
        const parsedJWT = parseJwt(jwt)

        if (!parsedJWT) return false
        return dayjs().unix() < dayjs.unix(parsedJWT.exp).unix()
    } catch (error) {
        return false
    }
}

export const hasRoles = (...roles: number[]): boolean => {
    const userRoles = useAppStore().getUserData().roles

    for (const role of roles) {
        if (!userRoles.includes(role)) return false
    }

    return true
}
